import * as CONST from 'Reducers/Clients/const'
import { CLEAR_ALL_FILTERS } from 'Reducers/Filter/const'
import * as CAMPAIGN_CONST from 'Reducers/Campaigns/const'

const initState = {
  clientsList: [],
  clientView: {},
  statusFilter: CONST.STATUS_FILTER.ACTIVE,
  // A hashmap of clients ids -> data
  clients: {},
}

export function clients(state = initState, action) {
  switch (action.type) {
    case CONST.GET_CLIENT_BY_ID_SUCCESS:
      return {
        ...state,
        clientView: action.payload.clientView,
      }

    case CONST.RESET_CLIENT_BY_ID:
      return {
        ...state,
        clientView: {},
      }

    case CONST.GET_CLIENTS_SUCCESS:
      return {
        ...state,
        clientsList: action.payload.clients,
      }

    case CONST.SET_STATUS_FILTER:
      return {
        ...state,
        statusFilter:
          Object.values(CONST.STATUS_FILTER).indexOf(action.statusFilter) > -1
            ? action.statusFilter
            : CONST.STATUS_FILTER.ACTIVE,
      }

    case CLEAR_ALL_FILTERS:
      return {
        ...state,
        statusFilter: initState.statusFilter,
      }

    case CAMPAIGN_CONST.GET_CAMPAIGN_RESULTS_SUCCESS:
      var client = action.result.data.campaign.client
      return {
        ...state,
        clients: {
          ...state.clients,
          [client.id]: {
            ...state.clients[client.id],
            ...client,
          },
        },
      }
    default:
      return state
  }
}
